import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  POSTBACKS_PERMISSIONS,
} from '@modules/postbacks/constants';

import type {
  IPostbackCondition,
  IPostbacksConditionsSaveResponse,
} from '../types';
import {
  ADMIN_POSTBACKS_CONDITION_SAVE_URL,
  AFFILIATE_POSTBACKS_CONDITION_SAVE_URL,
  POSTBACKS_SAVE_CONDITION_MUTATION_KEY,
} from '../constants';

function getPostbackConditionSaveUrl(isAdminNamespace: boolean): string {
  if (isAdminNamespace) {
    return ADMIN_POSTBACKS_CONDITION_SAVE_URL;
  }

  return AFFILIATE_POSTBACKS_CONDITION_SAVE_URL;
}

export default function usePostbackConditionSaveMutation(): IContextMutationResult<
  IPostbacksConditionsSaveResponse,
  Error,
  IPostbackCondition
> {
  const { fetchPut, fetchPost } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<IPostbacksConditionsSaveResponse, Error, IPostbackCondition>({
    mutationKey: [POSTBACKS_SAVE_CONDITION_MUTATION_KEY],
    mutationFn: ({
      affiliateId,
      postbackId,
      ...condition
    }) => (
      condition.id
        ? fetchPut<IPostbacksConditionsSaveResponse>(
            getPostbackConditionSaveUrl(isAdminNamespace.value),
            {
              condition,
            },
            {
              permission: POSTBACKS_PERMISSIONS.SHOW,
              urlParams: {
                id: affiliateId,
                postbackId,
                conditionId: condition.id,
              },
            },
          )
        : fetchPost<IPostbacksConditionsSaveResponse>(
            getPostbackConditionSaveUrl(isAdminNamespace.value),
            {
              condition,
            },
            {
              permission: POSTBACKS_PERMISSIONS.SHOW,
              urlParams: {
                id: affiliateId,
                postbackId,
                conditionId: condition.id,
              },
            },
          )
    ),
  });
}
